// Helpers for YouTube-driven portfolio media.

export const youTubeId = (url) => {
  if (!url) return null;
  const m = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/,
  );
  return m ? m[1] : null;
};

export const youTubeThumb = (url) => {
  const id = youTubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

export const youTubeEmbed = (url) => {
  const id = youTubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
};

export const vimeoId = (url) => {
  if (!url) return null;
  const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
};

export const isMp4 = (url) => /\.mp4(\?|#|$)/i.test(url || "");

// Detects the source of any portfolio video URL (YouTube, Vimeo, or direct MP4)
// and returns how to render it. { kind, id?, embed?, src? }
export const videoSource = (url) => {
  const clean = (url || "").trim();
  if (!clean) return { kind: null };
  const yt = youTubeId(clean);
  if (yt) return { kind: "youtube", id: yt, embed: `https://www.youtube.com/embed/${yt}` };
  const vm = vimeoId(clean);
  if (vm) return { kind: "vimeo", id: vm, embed: `https://player.vimeo.com/video/${vm}` };
  if (isMp4(clean)) return { kind: "mp4", src: clean };
  return { kind: null };
};
